import { Injector } from '@angular/core';
import { mergeAttributes, Node } from '@tiptap/core';
import { AngularNodeViewRenderer } from 'ngx-tiptap';
import { AccordionPanelComponent } from './accordion-panel.component';
import { ACCORDION_PANEL_NODE_NAME, DEFAULT_ACCORDION_PANEL_TITLE } from './accordion.model';

const panelClassName = 'accordion-panel-block';

export const AccordionPanelExtension = (injector: Injector) => {
  return Node.create({
    name: ACCORDION_PANEL_NODE_NAME,
    content: 'block+',
    defining: true,
    isolating: true,
    selectable: false,
    draggable: false,

    addAttributes() {
      return {
        title: {
          default: DEFAULT_ACCORDION_PANEL_TITLE,
        },
        icon: {
          default: '',
        },
        expanded: {
          default: false,
          rendered: false,
        },
      };
    },

    parseHTML() {
      return [{ tag: `div.${panelClassName}` }];
    },

    renderHTML({ HTMLAttributes }) {
      return ['div', mergeAttributes({ class: panelClassName }, HTMLAttributes), 0];
    },

    addNodeView() {
      return AngularNodeViewRenderer(AccordionPanelComponent, {
        injector,
      });
    },
  });
};
